// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__31UtI","content":"styles_content__tA-Bs","selectAll":"styles_selectAll__SiE2a"};